import { SharePointGroupPrincipalModel } from '../../microsoft/sharepoint/share-point-group-principal-model';

export class SharePointUserModel extends SharePointGroupPrincipalModel {
  email: string;
  userPrincipalName: string;
  description: string;
}
